import React, { memo } from "react";
import { Form } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useSelector } from "react-redux";

import { Button } from "components";

import styles from "../residuals.module.scss";

type SourceFilesFilterProps = {
	onSubmit: Function;
	getFilter: any;
	searchPlaceholder: string;
};
type FormFields = {
	paidMonth: { name: string; value: number };
	paidYear: { value: any; name: any };
	searchFor: string;
};

const SourceFilesFilter = ({
	onSubmit,
	getFilter,
	searchPlaceholder,
}: SourceFilesFilterProps) => {
	const { searchFor }: any = useSelector(getFilter);

	const methods = useForm<FormFields>({
		mode: "all",
		defaultValues: {
			searchFor,
		},
	});

	const { register, handleSubmit } = methods;

	const handleSubmitForm = ({ searchFor }) => {
		if (!searchFor) searchFor = "";
		onSubmit?.({ searchFor });
	};

	return (
		<FormProvider {...methods}>
			<form
				onSubmit={handleSubmit(handleSubmitForm)}
				className={styles.filterFiles}
			>
				<Form.Control
					{...register("searchFor")}
					className={styles.fileName}
					placeholder={searchPlaceholder}
				/>

				<Button
					type="submit"
					minWidth="auto"
					variant="secondary"
					value="Apply"
				/>
			</form>
		</FormProvider>
	);
};

const component = memo(SourceFilesFilter);
export { component as SourceFilesFilter };
